import api from "../api";

export const getWeaponCategories = async () => {
    const response = await api.get(`/api/weaponCategories`)
    return await response.data.map((category: any) => ({
        value: category.id,
        label: category.description
    }))
}

export const getWeaponOperarions = async () => {
    const response = await api.get(`/api/weaponOperations`)
    return await response.data.map((operation: any) => ({
        value: operation.id,
        label: operation.description
    }))
}

export const getWeaponCalibers = async () => {
    const response = await api.get(`/api/calibers`)
    return await response.data.map((caliber: any) => ({
        value: caliber.id,
        label: caliber.description
    }))
}
